// Native Domoxa homepage interactions.
function initDomoxaHomepage() {
  function initLazyBackgrounds() {
    var cards = Array.prototype.slice.call(
      document.querySelectorAll('.domoxa-home-solutions__card')
    );

    if (!cards.length) return;

    if (!('IntersectionObserver' in window)) {
      cards.forEach(function (card) {
        card.classList.add('is-background-loaded');
      });
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-background-loaded');
          observer.unobserve(entry.target);
        });
      },
      { rootMargin: '300px 0px' }
    );

    cards.forEach(function (card) {
      observer.observe(card);
    });
  }

  function initScrollCarousels() {
    document.querySelectorAll('[data-domoxa-carousel], [data-solutions-slider]').forEach(function (slider) {
      if (slider.dataset.domoxaSliderReady === 'true') return;

      var track = slider.querySelector('[data-domoxa-carousel-track]') || slider.querySelector('[data-solutions-track]');
      var slides = track ? Array.prototype.slice.call(track.children) : [];
      var prevButton = slider.querySelector('[data-domoxa-carousel-prev]') || slider.querySelector('.domoxa-home-solutions__nav--prev');
      var nextButton = slider.querySelector('[data-domoxa-carousel-next]') || slider.querySelector('.domoxa-home-solutions__nav--next');
      var pagination = slider.querySelector('[data-domoxa-carousel-pagination]') || slider.querySelector('[data-solutions-pagination]');

      if (!track || !slides.length || !pagination) return;
      slider.dataset.domoxaSliderReady = 'true';

      var snapPositions = [];

      function getStep() {
        if (slides.length > 1) return slides[1].offsetLeft - slides[0].offsetLeft;
        return slides[0].getBoundingClientRect().width;
      }

      function getSnapPositions() {
        var maxScroll = Math.max(track.scrollWidth - track.clientWidth, 0);
        var firstOffset = slides[0].offsetLeft;
        var positions = slides.map(function (slide) {
          return Math.min(Math.max(slide.offsetLeft - firstOffset, 0), maxScroll);
        });

        positions.push(maxScroll);

        return positions.filter(function (position, index, allPositions) {
          return index === 0 || Math.abs(position - allPositions[index - 1]) > 2;
        });
      }

      function positionsChanged(nextPositions) {
        if (nextPositions.length !== snapPositions.length) return true;

        return nextPositions.some(function (position, index) {
          return Math.abs(position - snapPositions[index]) > 2;
        });
      }

      function buildPagination(nextPositions) {
        snapPositions = nextPositions;
        pagination.innerHTML = '';

        snapPositions.forEach(function (position, index) {
          var dot = document.createElement('button');
          dot.type = 'button';
          dot.setAttribute('aria-label', 'Go to slide ' + (index + 1));
          dot.addEventListener('click', function () {
            track.scrollTo({
              left: position,
              behavior: 'smooth',
            });
          });
          pagination.appendChild(dot);
        });
      }

      function updateControls() {
        var nextPositions = getSnapPositions();
        var maxScroll = Math.max(track.scrollWidth - track.clientWidth, 0);
        var hasOverflow = maxScroll > 4;

        if (positionsChanged(nextPositions)) buildPagination(nextPositions);

        var activeIndex = snapPositions.reduce(function (closestIndex, position, index) {
          return Math.abs(position - track.scrollLeft) < Math.abs(snapPositions[closestIndex] - track.scrollLeft)
            ? index
            : closestIndex;
        }, 0);

        Array.prototype.forEach.call(pagination.children, function (dot, index) {
          dot.classList.toggle('is-active', index === activeIndex);
        });

        if (prevButton) prevButton.hidden = !hasOverflow;
        if (nextButton) nextButton.hidden = !hasOverflow;
        pagination.hidden = !hasOverflow;
      }

      if (prevButton) {
        prevButton.addEventListener('click', function () {
          track.scrollBy({
            left: -getStep(),
            behavior: 'smooth',
          });
        });
      }

      if (nextButton) {
        nextButton.addEventListener('click', function () {
          track.scrollBy({
            left: getStep(),
            behavior: 'smooth',
          });
        });
      }

      track.addEventListener('scroll', updateControls, { passive: true });
      window.addEventListener('resize', updateControls);
      updateControls();
      window.addEventListener('load', updateControls, { once: true });
    });
  }

  var startX = 0;
  var startY = 0;

  document.querySelectorAll('#nos-solutions .hover-card').forEach(function (card) {
    card.addEventListener('pointerdown', function (event) {
      startX = event.clientX || 0;
      startY = event.clientY || 0;
    });

    card.addEventListener('click', function (event) {
      if (event.target.closest('a,button,input,select,textarea,label')) return;

      var link = card.querySelector('.hover-overlay a[href]');
      if (!link) return;

      var clickX = event.clientX || 0;
      var clickY = event.clientY || 0;

      if (Math.abs(clickX - startX) > 8 || Math.abs(clickY - startY) > 8) return;

      window.location.href = link.getAttribute('href');
    });
  });

  initScrollCarousels();
  initLazyBackgrounds();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initDomoxaHomepage);
} else {
  initDomoxaHomepage();
}
